var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.656,
    height: 97.988,
    viewBox: "0 0 102.656 97.988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Apps_98676",
    transform: "translate(-145.716 124.125)",
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6818",
    "data-name": "Group 6818",
    transform: "translate(147.716 -122.125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M59.1,26.769V5.9a3.491,3.491,0,0,0-1.259-2.694,4.7,4.7,0,0,0-.543-.377,3.5,3.5,0,0,0-1.657-.422H7.238A3.479,3.479,0,0,0,3.78,5.9V92.917A3.47,3.47,0,0,0,7.238,96.4H55.644A3.463,3.463,0,0,0,59.1,92.917V67.325h-4.9v12.1H8.678V8.072H54.2v18.7Zm-27.667,55.7a5.006,5.006,0,1,1-4.966,5.012A4.994,4.994,0,0,1,31.436,82.472Z",
    transform: "translate(-3.78 -2.41)",
    fill: "none",
    stroke: "#f37320",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301",
    transform: "translate(17.611 38.867)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M39.665,38.926V54.461a2.46,2.46,0,0,1-2.454,2.464H21.676a2.47,2.47,0,0,1-2.466-2.464V38.926a2.47,2.47,0,0,1,2.466-2.466H37.211A2.46,2.46,0,0,1,39.665,38.926Z",
    transform: "translate(-19.21 -36.46)",
    fill: "none",
    stroke: "#f37320",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302",
    transform: "translate(71.786 10.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M90.77,17.21V37.62a3.238,3.238,0,0,1-3.23,3.242H76.913v-9.12A6.62,6.62,0,0,0,70.3,25.132H63.9V17.21a3.235,3.235,0,0,1,3.23-3.23H87.54A3.235,3.235,0,0,1,90.77,17.21Z",
    transform: "translate(-63.9 -13.98)",
    fill: "none",
    stroke: "#f37320",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303",
    transform: "translate(43.363 26.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M77.76,30.076V51.193H69.987a4.75,4.75,0,0,0-4.737,4.748v5.8H46.1a4.316,4.316,0,0,1-4.326-4.326V30.076A4.323,4.323,0,0,1,46.1,25.75H73.434A4.331,4.331,0,0,1,77.76,30.076Z",
    transform: "translate(-41.77 -25.75)",
    fill: "none",
    stroke: "#f37320",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304",
    transform: "translate(72.29 57.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M84.784,52.506V68.041a2.46,2.46,0,0,1-2.454,2.466H66.794a2.46,2.46,0,0,1-2.454-2.466V52.506a2.46,2.46,0,0,1,2.454-2.466H82.329A2.46,2.46,0,0,1,84.784,52.506Z",
    transform: "translate(-64.34 -50.04)",
    fill: "none",
    stroke: "#f37320",
    strokeWidth: 4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp);
export default __webpack_public_path__ + "static/media/app.8b693a839e4be29faf2708819d639f9b.svg";
export { ForwardRef as ReactComponent };